export enum CoordinationTransitionEnum {
    REQ_UNKNOWN = 'REQ_UNKNOWN',
    REQ_CREATE = 'REQ_CREATE',
    REQ_REMOVE = 'REQ_REMOVE',
    REQ_ACCEPTANCE = 'REQ_ACCEPTANCE',
    REQ_REVIEW = 'REQ_REVIEW',
    REQ_APPROVAL = 'REQ_APPROVAL',
    REQ_COORDINATE = 'REQ_COORDINATE',
    REQ_ACTIVATE = 'REQ_ACTIVATE',
    REQ_DEACTIVATE = 'REQ_DEACTIVATE',
    REQ_COMPLETE = 'REQ_COMPLETE',
    REQ_FINISH = 'REQ_FINISH',
    REQ_CANCEL = 'REQ_CANCEL',
    ACK_CANCEL = 'ACK_CANCEL',
    REQ_SUSPEND = 'REQ_SUSPEND',
    ACK_SUSPEND = 'ACK_SUSPEND',
    REQ_UNSUSPEND = 'REQ_UNSUSPEND',
    REQ_REJECT = 'REQ_REJECT',
}
